<template>
    <div>
        <div class="subheader actions">
            <div class="column-subheader-1">            
                <ul class="subheader-list left">
                    <li v-if="loggedIn"><router-link :to="{path: '/topics/list/mydiscussions'}"> <span @click="goToPage('/topics/list/mydiscussions')"> My Discussions </span></router-link></li>
                    <li><router-link :to="{path: '/topics/list/new'}" > <span @click="goToPage('/topics/list/new')"> New Topics </span></router-link></li>
                    <li><router-link :to="{path: '/topics/list/active'}" > <span @click="goToPage('/topics/list/active')"> Active Topics </span></router-link></li>
                    <li><router-link :to="{path: '/topics/list/unanswered'}" > <span @click="goToPage('/topics/list/unanswered')"> Unanswered Topics </span></router-link></li>
                </ul>
            </div>
            <div v-if="loggedIn" class="column-subheader-2">                    
                <ul class="subheader-list right">
                    <div class="notifications-container" @click.stop="seeNotifications">
                      <li><a href="#">Notifications</a><span v-if="notifications" id="notification-number">{{notifications}}</span></li>
                      <notification-list v-if="shouldShowNotifications"/>
                    </div>
                    <li><router-link :to="{path: '/messages'}">Messages</router-link></li>
                    <li><router-link :to="{path: '/guidelines'}">Guidelines</router-link></li>
                    <li><router-link :to="{path: '/topics/create' + this.createTopicBoardContext}"><button>New Topic</button></router-link></li>                    
                </ul>
            </div>
        </div>
        <div class="subheader breadcrumb">
            <div class="column-subheader-1">
                <div class="page-title">
                    <div class="breadcrumb" v-html="breadcrumb"></div>
                </div>
            </div>
        </div>
    </div>    
</template>


<script>
  import NotificationList from '../Notifications/NotificationList.vue';

    export default {
        data() {
            return {}
        },
        components: {NotificationList},
        computed: {     
            breadcrumb: function() {
                let x = this.$store.getters.breadcrumb;
                return x;
            },
            loggedIn: function () {
                return this.$store.getters.isLoggedIn === true;
            },
            loggedOut: function () {
                return this.$store.getters.isLoggedIn !== true;
            },
            showAdminLink: function() {
                return this.$store.getters.user.isModerator();
            },
            notifications() {
              if(!this.$store.getters['notifications/notifications']){
                if(this.$store.getters['auth/auth/notifications']){
                    return this.$store.getters['auth/auth/notifications'];
                }
                return 0;
              }
              return this.$store.getters['notifications/notifications'];
            },
            shouldShowNotifications() {
              return this.$store.getters['notifications/shouldShowNotifications'];
            },
            createTopicBoardContext() {
              let x = this.$store.getters.createTopicBoardContextID;
              if (x) {
                if (x !== null && x !== 0) {
                  return '/' + x;
                }
              }
              return '';
            }
        },
        methods: {
          seeNotifications() {
            this.$store.dispatch('notifications/seeNotifications');
          },
          goToPage(route) {
              if(route === this.$route.path) {
                  window.location.reload();
              }
          },
        }
    }
</script>
